export default __webpack_public_path__ + "static/media/footer-ywca-logo.881f8f35.png";